const RegisterInterestPlacements = {
  AFTER_SELECT_KPIS: "afterSelectKPIs",
  AFTER_METRICS: "afterMetrics",
  AFTER_SELECT_CHALLENGES: "afterSelectChallenges"
};

RegisterInterestPlacements.ALL = Object.values(RegisterInterestPlacements);

export default RegisterInterestPlacements;
